import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpIcon } from 'lucide-react';
export function BackToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-207" data-mp="2mph77htl0s4a">
      {visible && <motion.button type="button" aria-label="Back to top" onClick={() => window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })} initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={{
      duration: 0.25,
      ease: 'easeOut'
    }} className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-navy text-gold shadow-lift transition-colors hover:bg-navy-700" data-id="element-208" data-mp="2hrxkrumqd919">
          <ArrowUpIcon className="h-5 w-5" aria-hidden="true" data-id="element-209" data-mp="2spa9n0q71phy" />
        </motion.button>}
    </AnimatePresence>;
}